import React from "react";
import { Table, Tag, Empty, Button, Space, Input } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import ExportExcel from "../../../utils/export";

class TableOne extends React.Component {
  constructor(props) {
    super(props);
    const { permission } = this.props;
    this.state = {
      searchText: "",
      searchedColumn: "",
      tableOneData: this.props.tableOneData,
    };

  }

  getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${title ? title : dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, paddingLeft: "5px", paddingRight: "5px" }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),

  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  getUpdatedExcelBuffer = (data) => {
    const newData = data.map((i) => {
      const newData2 = { ...i };
      newData2.hotels_new = i.hotels
        ? i.hotels
          .map((k) => {
            return (
              k.hotel.hotel_code +
              " - " +
              k.hotel.hotel_name +
              " -  " +
              k.hotel.primary_hmg_id.hmg_id.hmg_name +
              " - " +
              k.hotel.primary_hmg_id.project_name +
              // `${k.hotel?.secondary_hmg_id?.hmg_id?.hmg_name ? " | " + k.hotel.secondary_hmg_id.hmg_id.hmg_name : ""}` +
              `${k.hotel?.secondary_hmg_id?.project_name ? " , " + k.hotel.secondary_hmg_id?.project_name : ""}` +
              // `${k.hotel?.third_hmg_id?.hmg_id?.hmg_name ? " | " + k.hotel.third_hmg_id.hmg_id.hmg_name : ""}` +
              `${k.hotel?.third_hmg_id?.project_name ? " , " + k.hotel.third_hmg_id?.project_name : ""}` +
              // `${k.hotel?.fourth_hmg_id?.hmg_id?.hmg_name ? " | " + k.hotel.fourth_hmg_id.hmg_id.hmg_name : ""}` +
              `${k.hotel?.fourth_hmg_id?.project_name ? " , " + k.hotel.fourth_hmg_id?.project_name : ""}`
            );
          })
          .join(", \n")
        : "";
      return newData2;
    });
    return newData;
  };

  exportOnClick = () => {
    const { tableOneData } = this.props;
    ExportExcel(
      this.columns,
      this.getUpdatedExcelBuffer(tableOneData),
      "User List",
    );
  };

  render() {
    const { tableOneData, firstLoad, permission } = this.props;
    const { searchedColumn, searchText } = this.state;

    this.columns = [
      {
        title: "User Name",
        dataIndex: "user_name",
        key: "user_name",
        width: "250px",
        ...this.getColumnSearchProps("user_name"),
        fixed: "left",
        render: (v, f) => <Link to={`/user/detail/${f._id}`}>
          {searchedColumn === "user_name" ? (
              <Highlighter
                highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={v ? v.toString() : ""}
              />
            ) : (
              v
            )
            }
        </Link>,
        sorter: (a, b) => {
          const aa = a.user_name ? a.user_name : "a";
          const bb = b.user_name ? b.user_name : "a";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Hotel Code - Hotel Name - HMG - Project Name",
        dataIndex: "hotels_new",
        key: "hotels_new",
        width: "700px",
        ...this.getColumnSearchProps("hotels_new", "Hotels"),
        render: (hotels) => (
          <div style={{ maxHeight: "220px", overflowY: "auto", whiteSpace: 'pre-line', }}>
            {searchedColumn === "hotels_new" ? (
              <Highlighter
                highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={hotels ? hotels.toString() : ""}
              />
            ) : (
              hotels
            )
            }
          </div>
        ),
      },
      {
        title: "First Name",
        dataIndex: "first_name",
        key: "first_name",
        width: "200px",
        ...this.getColumnSearchProps("first_name"),
        sorter: (a, b) => {
          const aa = a.first_name ? a.first_name : "a";
          const bb = b.first_name ? b.first_name : "a";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Last Name",
        dataIndex: "last_name",
        key: "last_name",
        width: "200px",
        ...this.getColumnSearchProps("last_name"),
        sorter: (a, b) => {
          const aa = a.last_name ? a.last_name : "a";
          const bb = b.last_name ? b.last_name : "a";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "250px",
        ...this.getColumnSearchProps("email"),
        sorter: (a, b) => {
          const aa = a.email ? a.email : "a";
          const bb = b.email ? b.email : "a";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Mobile",
        dataIndex: "mobile",
        key: "mobile",
        width: "200px",
        sorter: (a, b) => {
          const aa = a.mobile ? a.mobile : "0";
          const bb = b.mobile ? b.mobile : "0";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Main Role",
        dataIndex: "main_role",
        key: "main_role",
        width: "200px",
        ...this.getColumnSearchProps("main_role"),
        sorter: (a, b) => {
          const aa = a?.main_role ?? "a";
          const bb = b?.main_role ?? "a";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        width: "200px",
        ...this.getColumnSearchProps("role"),
        sorter: (a, b) => {
          const aa = a?.role ?? "a";
          const bb = b?.role ?? "a";
          return aa.localeCompare(bb);
        },
      },

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        // align: "center",
        width: "200px",
        render: (v) => {
          if (v === "Active") {
            return <Tag color="#71b443">Active</Tag>;
          }
          if (v === "Pending") {
            return <Tag color="#ffbc41">Pending</Tag>;
          }
          if (v === "Inactive") {
            return <Tag color="#697177">Inactive</Tag>;
          }
          return <Tag color="#3b6cb4">Created</Tag>;
        },
        sorter: (a, b) => {
          const aa = a?.status ?? "a";
          const bb = b?.status ?? "a";
          return aa.localeCompare(bb);
        },
      },
      ...(permission && permission.sm_solution_access
        ? [
          {
            title: "Custom Permission",
            dataIndex: "custom_permission",
            key: "custom_permission",
            width: "200px",
            render: (v) =>
              v === "Enable" ? (
                <Tag color="blue">Enable</Tag>
              ) : (
                <Tag color="red">Disable</Tag>
              ),
            sorter: (a, b) => {
              const aa =
                a.custom_permission && a.custom_permission === "Enable"
                  ? "a"
                  : "b";
              const bb =
                b.custom_permission && b.custom_permission === "Enable"
                  ? "a"
                  : "b";
              return aa.localeCompare(bb);
            },
          },
        ]
        : []),
      ...(permission && permission.sm_solution_access
        ? [
          {
            title: "Multi Factor Authentication",
            dataIndex: "use_mfa",
            key: "use_mfa",
            width: "250px",
            render: (v) =>
              v === "Enable" ? (
                <Tag color="blue">Enable</Tag>
              ) : (
                <Tag color="red">Disable</Tag>
              ),
            sorter: (a, b) => {
              const aa = a.use_mfa && a.use_mfa === "Enable" ? "a" : "b";
              const bb = b.use_mfa && b.use_mfa === "Enable" ? "a" : "b";
              return aa.localeCompare(bb);
            },
          },
        ]
        : []),
      ...(permission && permission.sm_solution_access
        ? [
          {
            title: "MYP User ID",
            dataIndex: "myp_id",
            key: "myp_id",
            width: "200px",
            ...this.getColumnSearchProps("myp_id"),
            sorter: (a, b) => {
              const aa = a.myp_id || 0;
              const bb = b.myp_id || 0;
              return aa - bb;
            },
          },
        ]
        : []),
      {
        title: "MYP Role",
        dataIndex: "myp_role",
        key: "myp_role",
        width: "200px",
        ...this.getColumnSearchProps("myp_role"),
        sorter: (a, b) => {
          const aa = a?.myp_role ?? "a";
          const bb = b?.myp_role ?? "a";
          return aa.localeCompare(bb);
        },
      },

      {
        title: "Created by",
        dataIndex: "create_by",
        key: "create_by",
        width: "200px",
        sorter: (a, b) => {
          const aa = a?.create_by ?? "a";
          const bb = b?.create_by ?? "a";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Created at",
        dataIndex: "create_at",
        key: "create_at",
        width: "200px",
        sorter: (a, b) => {
          const aa = a?.create_at ?? "0";
          const bb = b?.create_at ?? "0";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Updated by",
        dataIndex: "update_by",
        key: "update_by",
        width: "200px",
        sorter: (a, b) => {
          const aa = a?.update_by ?? "a";
          const bb = b?.update_by ?? "a";
          return aa.localeCompare(bb);
        },
      },
      {
        title: "Updated at",
        dataIndex: "update_at",
        key: "update_at",
        width: "200px",
        sorter: (a, b) => {
          const aa = a?.update_at ?? "0";
          const bb = b?.update_at ?? "0";
          return aa.localeCompare(bb);
        },
      },
    ];

    let tableHeight = 500;
    if (window.innerWidth > 700) {
      tableHeight = window.innerHeight - 388;
    }

    return (
      <div>
        {firstLoad ? (
          <Empty description="Please select your filters and click the Go button" />
        ) : (
          <div>
            {tableOneData.length > 0 ? (
              <div className="is_table_3 a01">
                <Table
                  className="sm-custom-column-header"
                  columns={this.columns}
                  dataSource={tableOneData}
                  // size="small"
                  rowKey="_id"
                  scroll={{ x: 1100, y: tableHeight }}
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                  }}
                />
              </div>
            ) : (
              <Empty description="No users found" />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default TableOne;
